import { render, staticRenderFns } from "./HotelSummary.vue?vue&type=template&id=bbe572d2"
import script from "./HotelSummary.vue?vue&type=script&lang=js"
export * from "./HotelSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports